import React, { useState, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useIntl } from "react-intl";
import StorageResourcePage, { ActiveTag } from "./StorageResourcePage";
import DeleteLocationConfirmModal from "../components/DeleteLocationConfirmModal";

/** ShelvesPage — /Storage/shelves. List of shelves with per-row Edit. */
export default function ShelvesPage() {
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [deleteTarget, setDeleteTarget] = useState(null);

  const mapRow = useCallback(
    (s) => ({
      id: String(s.id),
      label: s.label || s.name || "",
      code: s.code || "",
      device: s.parentDeviceName || s.deviceName || "",
      active: <ActiveTag active={s.active !== false} />,
    }),
    [],
  );

  return (
    <>
      <StorageResourcePage
        crumbs={[
          {
            label: intl.formatMessage({
              id: "storage.breadcrumb.storage",
              defaultMessage: "Storage",
            }),
            href: "/Storage",
          },
          {
            label: intl.formatMessage({
              id: "storage.nav.shelves",
              defaultMessage: "Shelves",
            }),
            href: "/Storage/shelves",
          },
        ]}
        heading={intl.formatMessage({
          id: "storage.nav.shelves",
          defaultMessage: "Shelves",
        })}
        listUrl="/rest/storage/shelves"
        headers={[
          {
            key: "label",
            header: intl.formatMessage({
              id: "label.label",
              defaultMessage: "Label",
            }),
          },
          {
            key: "code",
            header: intl.formatMessage({
              id: "label.code",
              defaultMessage: "Code",
            }),
          },
          {
            key: "device",
            header: intl.formatMessage({
              id: "storage.nav.device",
              defaultMessage: "Device",
            }),
          },
          {
            key: "active",
            header: intl.formatMessage({
              id: "label.status",
              defaultMessage: "Status",
            }),
          },
        ]}
        mapRow={mapRow}
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
        editHref={(shelf) => `/Storage/shelves/${shelf.id}/edit`}
        addHref="/Storage/shelves/new"
        onDeleteRequested={setDeleteTarget}
      />
      <DeleteLocationConfirmModal
        isOpen={Boolean(deleteTarget)}
        type="shelf"
        location={deleteTarget}
        onClose={() => setDeleteTarget(null)}
        onDeleted={() => {
          setDeleteTarget(null);
          history.replace({
            pathname: location.pathname,
            search: `?t=${Date.now()}`,
          });
        }}
      />
    </>
  );
}
